import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnChanges, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppIcons } from 'app/modules/shared/app.icons';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  selector: 'app-overview-details',
  standalone: true,
  imports: [
    ButtonModule, TranslateModule, DropdownModule, ChartModule, OverlayPanelModule, FormsModule,
    CommonModule
],
  templateUrl: './overview-details.component.html',
  styleUrl: './overview-details.component.scss'
})
export class OverviewDetailsComponent implements OnChanges, OnInit {

  miIcons = AppIcons;
  iconPos: any = 'right';
  @Input() attributeValues: any;
  @Input() attributeLabels: any;
  @Input() protocolAttributeData: any;
  @Input() protocolReviewRequestId;
  @Input() changeReviewRowData;
  @Input() changeReviewDetails;
  @Input() protocolRefID;
  @Input() entityCode;
  @Output() onToggleOverLay: EventEmitter<boolean> = new EventEmitter();
  dd_MMM_yyyy_FORMAT: any = AppSettings.dd_MMM_yyyy_hh_mm_FORMAT2;

  dropDownItems: any[] = [];
  selectedItem: any = [];
  data: any;
  options: any;
  tab: any;
  details: any;
  center: google.maps.LatLngLiteral = {
    lat: 24,
    lng: 12,
  };
  zoom = 4;
  map: google.maps.Map;
  bulkRowCount = 1;
  barcodeImage;
  visiblePrintLabel: boolean = false;
  rowData;
  isLoading: boolean = false;
  selectedEventId: any;
  eventLat: any;
  eventLng: any;
  marker: any;
  regionGeofences: any = [];
  zoneIds: any = [];
  fields: any;
  regionGeofence: any;
  matchedZoneDisplayName: string = '';

  constructor(public vehicleService: EntityService,
    public cs: CommonBindingDataService,
    private router: Router,
    public metaDataService: MetaDataService
  ) { }

  ngOnChanges() {
    this.rowData = this.attributeValues;
  }

  ngOnInit() {

  }

  scrollToTop() {

    const tabviewPanels = document.querySelector('.p-tabview-panels');
    if (tabviewPanels) {
      tabviewPanels.scrollTop = 0;
    }
  }

  redirectToEdit() {
   let tab: string;

    if (this.entityCode === 'protocol_product') {
      tab = 'products';
    } else if (this.entityCode === 'protocol_purchase_order') {
      tab = 'purchase-orders';
    } else if (this.entityCode === 'protocol_sponsor') {
      tab = 'sponsors';
    } else if (this.entityCode === 'protocol_user') {
      tab = 'protocol-users';
    } else if (this.entityCode === 'protocol_patient') {
      tab = 'patients';
    } else if (this.entityCode === 'protocol_site') {
      tab = 'sites';
    } else if (this.entityCode === 'order') {
      tab = 'orders';
    } else {
      tab = 'overview';
    }

    this.router.navigate(['app/trials/trial-details'], {
      queryParams: {
        tab,
        id: this.protocolRefID
      }
    });
  }
}
